import {Box, Button, Paper, Typography} from '@mui/material';
import React, {useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
import GoalForm from '../Goals/GoalForm';
import {HandoverStep} from '../../../components/HandoverStep/HandoverStep';
import {FeatureBoundary} from '../../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../../schema-types/globalTypes';
import theme from '../../../theme/Theme';

interface DialogButtonProps {
  hidden?: boolean;
  onClick: () => void;
  children: string;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained' | undefined;
}

export const DialogButton = (props: DialogButtonProps) => {
  const {hidden = false} = props;
  if (hidden) {
    return null;
  }
  return (
    <Button
      variant="outlined"
      color="primary"
      sx={{
        marginLeft: '1rem',
        marginRight: '1rem',
        marginBottom: '1rem',
      }}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    />
  );
};

export type goalContextType = {
  setDirection: React.Dispatch<React.SetStateAction<'forward' | 'backward'>>;
  direction: 'forward' | 'backward';
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  activeStep: number;
  setRequireValidation: React.Dispatch<React.SetStateAction<string[]>>;
  requireValidation: string[];
  submitting: boolean;
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GoalContext = React.createContext<goalContextType>({
  direction: 'forward',
  setDirection: () => {},
  activeStep: 0,
  setActiveStep: () => {},
  requireValidation: [],
  setRequireValidation: () => {},
  submitting: false,
  setSubmitting: () => {},
});

const CreateGoal = () => {
  const {reviewId} = useParams();
  const [activeStep, setActiveStep] = React.useState(0);
  const [submitting, setSubmitting] = React.useState(false);
  const [direction, setDirection] = React.useState<'forward' | 'backward'>('forward');
  // Keep track of which fields need validation
  const [requireValidation, setRequireValidation] = React.useState<string[]>([]);
  const [goalFormName, setGoalFormName] = useState('Goal Editor');
  const exitURL = '../goals';
  const goalsValue: goalContextType = useMemo(() => {
    return {
      direction,
      setDirection,
      activeStep,
      setActiveStep,
      requireValidation,
      setRequireValidation,
      submitting,
      setSubmitting,
    };
  }, [
    direction,
    setDirection,
    activeStep,
    setActiveStep,
    requireValidation,
    setRequireValidation,
    submitting,
    setSubmitting,
  ]);
  return (
    <FeatureBoundary
      showErrorIfDenied
      features={[GlobalPermissionEnum.can_access_ehons_notes_goals]}
    >
      {reviewId ? <HandoverStep /> : null}
      <GoalContext.Provider value={goalsValue}>
        <Paper
          sx={{
            padding: theme.spacing(2),
          }}
        >
          <Box display="flex" flexDirection="row">
            <Typography variant="h5">{goalFormName}</Typography>
          </Box>
          <GoalForm exitURL={exitURL} setGoalFormName={setGoalFormName} />
        </Paper>
      </GoalContext.Provider>
    </FeatureBoundary>
  );
};

export default CreateGoal;
